import { render } from "./MessagingPanel.vue?vue&type=template&id=48e68b14&scoped=true"
import script from "./MessagingPanel.vue?vue&type=script&lang=js"
export * from "./MessagingPanel.vue?vue&type=script&lang=js"

import "./MessagingPanel.vue?vue&type=style&index=0&id=48e68b14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e68b14"]])

export default __exports__